import { addDays, format, subDays } from "date-fns";
import {
  Product,
  Arts,
  Flyer,
  RequestArtParams,
  RequestNewAdvertising,
  RequestNewAdvertisingProduct,
} from "../types/arts";
import api from "./api";

export const listArts = async (data: RequestArtParams): Promise<Arts[]> => {
  const params = {
    nome: data.name,
    dataInicio: format(data.startDate, "yyyy-MM-dd"),
    dataFim: format(data.endDate, "yyyy-MM-dd"),
    id_tabloide: data.tabloidId,
  };

  const response = await api.get(
    "tabloide-digital-p1-:stage/:stage/crm/getTabloidesDigitais",
    { params }
  );

  return response.data;
};

export const listFlyers = async (id: number): Promise<Flyer[]> => {
  const params = { offer_id: id };

  const response = await api.get("editor-:stage/flyers", {
    params,
  });

  return response.data.content;
};

export const listProducts = async (name: string): Promise<Product[]> => {
  const params = { nome: name, limit: 15 };
  const response = await api.get("lista-ofertas-p1-:stage/getProdutoNome", {
    params,
  });

  return response.data.response;
};

export const putProduct = async (data: any): Promise<any> => {
  const response = await api.put(
    "tabloide-digital-p1-:stage/:stage/crm/putTdProduto",
    data
  );

  return response.data;
};

export const createAdvertising = async (
  nameAdvertising: string
): Promise<any> => {
  const requestData: RequestNewAdvertising = {
    colors: {
      background: "#fff",
      card: "#fff",
      description: "rgba(0, 0, 0, 0.87)",
      percent: "rgba(0, 0, 0, 0.87)",
      productDiscountPrice: "rgba(0, 0, 0, 0.87)",
      productName: "rgba(0, 0, 0, 0.87)",
      productPrice: "rgba(0, 0, 0, 0.87)",
    },
    data_inicio: format(subDays(new Date(), 1), "yyyy-MM-dd"),
    data_fim: format(addDays(new Date(), 13), "yyyy-MM-dd"),
    nome_tabloide: nameAdvertising,
  };

  const response = await api.post(
    "tabloide-digital-p1-:stage/:stage/crm/postTabloideDigital",
    requestData
  );

  return response.data;
};

export const createAdvertisingProduct = async (product: Product) => {
  const requestData: RequestNewAdvertisingProduct = {
    dinamica_comercial: product.dinamica_comercial,
    id_tabloide_digital: product.id_tabloide_digital,
    imagemPrincipal: [
      {
        imagem_produto: product.imagem_produto,
        imagem_produto_original_link: product.imagem_produto_original_link,
        imagem_produto_original_s3: product.imagem_produto_original_s3,
      },
    ],
    imagem_produto: product.imagem_produto,
    produto_ativo: product.produto_ativo,
    imagem_produto_original_link: product.imagem_produto_original_link,
    imagem_produto_original_s3: product.imagem_produto_original_s3,
    isOfertaSecreta: false,
    nome_produto: product.nome_produto,
    preco_dois: product.preco_dois,
    preco_original: product.preco_original,
    ean: product.ean,
    id_produto: product.id_produto,
  };
  const response = await api.post(
    "tabloide-digital-p1-:stage/:stage/crm/produto",
    {
      produto: requestData,
    }
  );

  return response.data;
};
